import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Heading } from '../../component-heading';
import { forwardRef } from 'react';
/**
 * The `PopoverHeading` should be used to display the headline within the `Popover`.
 */
export const PopoverHeadline = forwardRef((props, ref) => (_jsx(Heading, { color: "surface-onBase-50", ...props, ref: ref })));
PopoverHeadline.displayName = 'PopoverHeadline';
